import { render, staticRenderFns } from "./content-contact.vue?vue&type=template&id=34d528e3&"
import script from "./content-contact.vue?vue&type=script&lang=js&"
export * from "./content-contact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports